export const META_PRICING_CHANGE = '2026-10';
export const META_CATEGORIES = {
  service: 'Serviço',
  utility: 'Utilidade',
  authentication: 'Autenticação',
  marketing: 'Marketing',
};

const count = value => {
  const number = Number(value);
  return Number.isSafeInteger(number) && number >= 0 ? number : 0;
};

// Quantities are delivered messages for one number/month. The 24h utility
// quantity excludes free-entry deliveries, so exemptions never overlap.
export function calculateMetaPricing({
  month,
  quantities = {},
  freeEntry = {},
  utilityWindow = 0,
  serviceAllowance = 0,
  rates = {},
}) {
  const updated = month >= META_PRICING_CHANGE;
  const rows = Object.keys(META_CATEGORIES).map(category => {
    const delivered = count(quantities[category]);
    const entryFree = Math.min(delivered, count(freeEntry[category]));
    const remaining = delivered - entryFree;
    let exempt = 0;
    if (category === 'service')
      exempt = updated
        ? Math.min(remaining, count(serviceAllowance))
        : remaining;
    if (category === 'utility' && !updated)
      exempt = Math.min(remaining, count(utilityWindow));
    const billable = remaining - exempt;
    const rawRate = rates[category];
    const rate = rawRate === '' || rawRate == null ? null : Number(rawRate);
    const validRate =
      rate !== null && Number.isFinite(rate) && rate >= 0 && rate <= 1000;
    // Six decimal places for rates, round only after summing each category.
    const costMicros = validRate ? Math.round(rate * 1e6) * billable : 0;
    return {
      category,
      delivered,
      free: entryFree + exempt,
      billable,
      rate: validRate ? rate : null,
      unpriced: validRate ? 0 : billable,
      costMicros,
    };
  });
  return {
    rows,
    total: rows.reduce((sum, row) => sum + row.costMicros, 0) / 1e6,
    unpriced: rows.reduce((sum, row) => sum + row.unpriced, 0),
  };
}
